<style src="./Toggler.scss" lang="scss"></style>

<template lang="pug">
  .toggler
    ul.toggler__list
      li.toggler__item(
        v-for='item in list'
      )
        button.toggler__trigger(
          type='button'
          :class='{"is-active": item.id === value }'
          @click='clickHandler(item.id)'
        ) {{ item.label }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    clickHandler(id) {
      this.$emit("input", id);
    }
  }
};
</script>
